/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_PaymentInputs */

const en_loading_payment = /** @type {(inputs: Loading_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing your payment…`)
};

const id_loading_payment = /** @type {(inputs: Loading_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyiapkan pembayaranmu…`)
};

/**
* | output |
* | --- |
* | "Preparing your payment…" |
*
* @param {Loading_PaymentInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const loading_payment = /** @type {((inputs?: Loading_PaymentInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_PaymentInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_loading_payment(inputs)
	return en_loading_payment(inputs)
});